import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserService } from '@app/core/services/UserService';

export const paySlipImportAdminGuard: CanActivateFn = () =>
  inject(UserService).userHasRole('admin') || inject(Router).createUrlTree(['/']);
